"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Box_1 = require("../Box");
var theme_1 = require("../theme");
var mixins_1 = require("../mixins");
var onlyText_1 = __importDefault(require("../lib/onlyText"));
var Placeholder = (0, styled_components_1.default)(Box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: 0;\n  pointer-events: none;\n"], ["\n  opacity: 0;\n  pointer-events: none;\n"])));
exports.Container = (0, styled_components_1.default)(Box_1.Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  ", "\n\n  > a {\n    color: inherit;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  display: inline-block;\n  ", "\n\n  > a {\n    color: inherit;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  ", "\n"])), mixins_1.overflowEllipsisMixin, function (props) {
    var bg = (0, theme_1.themeGet)("colors.".concat(props.bg), props.bg)(props);
    var color = (0, theme_1.getContrastTIQHex)(bg);
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n\n      &:focus-within {\n        background-color: ", ";\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n\n      &:focus-within {\n        background-color: ", ";\n        color: ", ";\n      }\n    "])), color, color, bg);
});
var Tag = function (_a) {
    var children = _a.children, bg = _a.bg, backgroundColor = _a.backgroundColor, rest = __rest(_a, ["children", "bg", "backgroundColor"]);
    var _bg = bg || backgroundColor || (0, theme_1.colorHash)((0, onlyText_1.default)(children));
    return (react_1.default.createElement(exports.Container, __assign({ fontSize: 1, borderRadius: 4, px: 3, py: 1, bg: _bg }, rest), typeof children === "string" ? (children) : (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(Placeholder, null, (0, onlyText_1.default)(children))))));
};
exports.Tag = Tag;
exports.Tag.displayName = "Tag";
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Tag.js.map